import React from 'react';
import Drawer, { FooterSpacer } from '../Drawer';
import Button from '../Button';
import Field from '../Field';
import { EXPENSE_CATEGORY_MAX } from '../../domain/expenses';
import s from './EntryForm.module.css';

// Pushed over the entry form, so both back and close return to it rather than
// dropping the half-filled entry behind them.
//
// `error` is the duplicate-name refusal (#144), the same rule and the same
// sentence the category manager uses — this is the other door into the same
// collection, and a studio should not be able to reach through one what the
// other refuses.
export default function NewCategoryDrawer({ open, value, onChange, onBack, onSave, error }) {
  return (
    <Drawer
      open={open}
      onBack={onBack}
      onClose={onBack}
      title="New Category"
      width={560}
      footer={(
        <>
          <FooterSpacer />
          <Button variant="secondary" onClick={onBack}>Cancel</Button>
          <Button disabled={!value.trim()} onClick={onSave}>Save</Button>
        </>
      )}
    >
      <div className={s.body}>
        {/* See the note on the same field in the category manager's drawer. */}
        <Field label="Name" htmlFor="new-expense-category-name" hint="e.g. Sheet Music" error={error}>
          <input id="new-expense-category-name" className={s.input} value={value} autoFocus
                 maxLength={EXPENSE_CATEGORY_MAX}
                 data-error={error ? 'true' : undefined}
                 onChange={(e) => onChange(e.target.value)} />
        </Field>
      </div>
    </Drawer>
  );
}
